import { Typography, Icon } from '@design-system';
import React from 'react';
import './Favorite.scss';
import { mapRefToFavorite } from './mapRefToFavorite';
import { FavoriteRef } from '@services';
import { useNavigate } from 'react-router-dom';
export type FavoriteProps = {
    reference: FavoriteRef;
} & React.HTMLAttributes<HTMLDivElement>;

export const Favorite: React.FC<FavoriteProps> = ({ reference, className, ...props }) => {
    const navigate = useNavigate();
    const { color, icon, label, link } = mapRefToFavorite(reference);

    return (
        <div data-color={color} {...props} className={`favorite ${className ?? ''}`} onClick={() => navigate(link)}>
            <Icon
                icon={icon}
                size={20}
                color={color as 'white' | 'marine' | 'grey' | 'yellow' | 'green' | 'red' | 'blue'}
                variant="surrounded"
            />

            <Typography intrinsic="h5">{label}</Typography>
        </div>
    );
};
